/**
 * @generated SignedSource<<1594c3bffbdfef1ea50919c3af7d16e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stripeConnectorPage_SyncMutation$variables = {
  mode?: string | null | undefined;
  objectTypes?: ReadonlyArray<string> | null | undefined;
};
export type stripeConnectorPage_SyncMutation$data = {
  readonly stripeSyncStart: {
    readonly enqueued: boolean;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly mode: string | null | undefined;
  } | null | undefined;
};
export type stripeConnectorPage_SyncMutation = {
  response: stripeConnectorPage_SyncMutation$data;
  variables: stripeConnectorPage_SyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "objectTypes"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "mode",
    "variableName": "mode"
  },
  {
    "kind": "Variable",
    "name": "objectTypes",
    "variableName": "objectTypes"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enqueued",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stripeConnectorPage_SyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StripeSyncStartMutationPayload",
        "kind": "LinkedField",
        "name": "stripeSyncStart",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stripeConnectorPage_SyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StripeSyncStartMutationPayload",
        "kind": "LinkedField",
        "name": "stripeSyncStart",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "03aca3422af9c1ce8365f83a63402b72",
    "id": null,
    "metadata": {},
    "name": "stripeConnectorPage_SyncMutation",
    "operationKind": "mutation",
    "text": "mutation stripeConnectorPage_SyncMutation(\n  $mode: String\n  $objectTypes: [String!]\n) {\n  stripeSyncStart(mode: $mode, objectTypes: $objectTypes) {\n    enqueued\n    mode\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "92029b763b9fb1da05d5c94bd0a8919b";

export default node;
